interface RegExpConstructor {
  escape: (val: string) => RegExp;
}

RegExp.escape = (val: string) => {
  return new RegExp(val.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1'));
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/extensions/reg-exp+escape.ts